import { ReactElement } from "react";

export const ShowChartIcon = (color?: string, crossed?: boolean): ReactElement => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" fill="none" viewBox="0 0 18 19">
      <path
        stroke={color ?? '#2F446C'}
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M6.75 14.25v-4.5a1.5 1.5 0 00-1.5-1.5h-1.5a1.5 1.5 0 00-1.5 1.5v4.5a1.5 1.5 0 001.5 1.5h1.5a1.5 1.5 0 001.5-1.5zm0 0v-7.5a1.5 1.5 0 011.5-1.5h1.5a1.5 1.5 0 011.5 1.5v7.5m-4.5 0a1.5 1.5 0 001.5 1.5h1.5a1.5 1.5 0 001.5-1.5m0 0V3.75a1.5 1.5 0 011.5-1.5h1.5a1.5 1.5 0 011.5 1.5v10.5a1.5 1.5 0 01-1.5 1.5h-1.5a1.5 1.5 0 01-1.5-1.5z"
        opacity="0.89"
      ></path>
      {crossed && <path stroke="#45587C" d="M0.587 17.707L17.657 1.636"></path>}
    </svg>
  );
};
